import React, { useEffect, useRef, useState, useCallback } from 'react';
import { useTheme } from '../context/ThemeContext';
import './ToolPage.css';

/**
 * VideoLibrary
 * ────────────
 * Hosts /public/videoLibrary.html in an iframe and keeps it in sync
 * with the user's theme + font-size preferences. Mirrors the pattern
 * used by Estimator / GuidedPlanner / DetailedPlanner.
 */
export default function VideoLibrary() {
  const iframeRef = useRef(null);
  const [iframeReady, setIframeReady] = useState(false);
  const { theme, fontSize } = useTheme();

  const syncSettings = useCallback(() => {
    iframeRef.current?.contentWindow?.postMessage(
      { type: 'SET_THEME', theme, fontSize },
      '*'
    );
  }, [theme, fontSize]);

  // Echo current settings whenever the iframe becomes ready
  useEffect(() => {
    function handleMessage(event) {
      if (!event.data || typeof event.data !== 'object') return;
      if (event.data.type === 'LIBRARY_READY') {
        setIframeReady(true);
        setTimeout(() => {
          iframeRef.current?.contentWindow?.postMessage(
            { type: 'SET_THEME', theme, fontSize },
            '*'
          );
        }, 50);
      }
    }
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [theme, fontSize]);

  // Push theme/fontSize whenever they change while the iframe is open
  useEffect(() => {
    if (!iframeReady) return;
    syncSettings();
  }, [theme, fontSize, iframeReady, syncSettings]);

  return (
    <div className="tool-page">
      <div className="tool-toolbar">
        <div className="tool-toolbar-left">
          <h2 className="tool-title">Video Library</h2>
        </div>
      </div>

      <div className="tool-frame-wrapper">
        <iframe
          ref={iframeRef}
          src="/tools/videoLibrary.html"
          title="Retirement Video Library"
          className="tool-iframe"
          sandbox="allow-scripts allow-same-origin allow-presentation allow-popups allow-popups-to-escape-sandbox"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        />
      </div>
    </div>
  );
}